/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextNumberedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Numbered',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M4.42 29.688c-.076 0-.106-.03-.106-.107v-1.516c0-.092 0-.153.092-.153l.763-.007c1.073 0 1.654-.322 1.654-1.026 0-.674-.566-1.118-1.685-1.118a4.712 4.712 0 0 0-2.266.582c-.092.046-.106 0-.106-.061v-1.517c0-.092-.016-.122.076-.168A5.655 5.655 0 0 1 5.506 24c2.022 0 3.277 1.01 3.277 2.6a2.168 2.168 0 0 1-1.347 2.006A2.434 2.434 0 0 1 9.259 31c0 1.96-1.808 3-3.921 3a5.524 5.524 0 0 1-2.619-.505c-.092-.031-.092-.123-.092-.2v-1.653c0-.061.077-.092.139-.061a5.234 5.234 0 0 0 2.5.643c1.377 0 1.914-.567 1.914-1.287 0-.811-.582-1.256-1.854-1.256ZM5.07 1.976a12.906 12.906 0 0 1-1.628.424c-.1.015-.136-.015-.136-.1V.98c0-.075.016-.12.106-.135a9.669 9.669 0 0 0 1.949-.77A.557.557 0 0 1 5.617 0H7.1c.075 0 .09.045.09.106v8.076h1.346c.106 0 .136.045.151.136v1.516c.015.121-.031.166-.121.166H3.627c-.106 0-.136-.045-.121-.136V8.318a.145.145 0 0 1 .166-.136h1.4ZM2.514 22c-.1 0-.12-.045-.12-.135v-1.076a.214.214 0 0 1 .075-.2 36.9 36.9 0 0 0 2.812-2.528c1.181-1.151 1.7-1.895 1.7-2.733 0-.942-.769-1.493-1.906-1.493a5.366 5.366 0 0 0-2.407.658c-.09.045-.15.015-.15-.09v-1.476a.17.17 0 0 1 .09-.179A5.7 5.7 0 0 1 5.565 12 3 3 0 0 1 8.9 14.982a4.4 4.4 0 0 1-1.545 3.412 23.268 23.268 0 0 1-1.9 1.831c1.032 0 3.158-.028 4.04-.028.105 0 .12.03.105.135l-.445 1.548a.149.149 0 0 1-.165.12Z"
    />
    <rect height="4" rx="1" ry="1" width="22" x="14" y="4" />
    <rect height="4" rx="1" ry="1" width="22" x="14" y="16" />
    <rect height="4" rx="1" ry="1" width="22" x="14" y="28" />
  </svg>`;
};
